import { gitHubUrl, profileCartDetails, selfIntroduction } from '../constants/About';
import styles from './styles/About.module.css';


const About = () => {
    return (
        <div className={styles.container} >

            <div className={styles.about}>
                <p>
                    {selfIntroduction}
                </p>
                <a href={gitHubUrl} target="_blank" style={{ textDecoration: 'none' }} rel="noopener noreferrer">
                    <div className={styles.githubBanner}>
                        <img src={`${process.env.PUBLIC_URL}/image/github.png`} className={styles.githubLogo}
                            onClick={() => window.open(`${process.env.PUBLIC_URL}/image/StickEnquiry.png`, '_blank')}
                            style={{ cursor: 'pointer' }}
                            alt="GitHub Logo"
                        />
                        GitHub
                    </div>
                </a>
            </div>

            <div className={styles.background}> </div>

            <div className={styles.profileCardContainer}>
                {profileCartDetails.map((item, index) =>
                    <ProfileCard
                        key={index}
                        image={item.image}
                        header1={item.header1}
                        header2={item.header2}
                        tools={item.tools}
                    />
                )}
            </div>

        </div>

    )
}

export default About;

const ProfileCard = ({ image, header1, header2, tools, style }) => {
    return (
        <div className={styles.profileCard} style={{ ...style }}>
            <img src={`${process.env.PUBLIC_URL}${image}`} className={styles.profileCardImage} alt={`${header1} ${header2}`} />
            <div className={styles.profileCardHeader1}>{header1}</div>
            <div className={styles.profileCardHeader2}>{header2}</div>
            <div className={styles.toolsContainer}>
                {tools && tools.map((item, index) =>
                    <div className={styles.profileCardTool} key={index}>
                        {item}
                    </div>
                )}
            </div>

        </div>
    )
}